enum Title {
  CEO = "CEO",
  COO = "COO",
  CFO = "CFO",
  PRESIDENT = "President",
  VICE_PRESIDENT = "Vice President",
  TREASURER = "Treasurer",
  OWNER = "Owner",
  Other = "Other",
}

export default Title;
